import styled from "styled-components";
export const ReportsDetailWrap = styled.div`
  .transaction-detail {
    padding: 15px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
    margin-bottom: 30px;
    .detail-wrap{
      display: grid;
      gap: 15px;
      grid-template-columns: repeat(2, 1fr);
      @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
      }
      @media (min-width: 1200px) {
        grid-template-columns: repeat(6, 1fr);
      }
      .card{
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        border-right: 1px solid #CDCDCD;
        padding-right: 10px;
        &:last-child {
          border-right: none;
        }
        @media (max-width: 1199px) {
          border-right: none;
          padding-right: 0;
        }
        strong{
          display: block;
          margin-bottom: 8px;
          font-size: 15px;
          line-height: 18px;
          font-weight: 400;
          color: rgba(119, 119, 119, 1);
        }
        p {
          font-size: 14px;
          color: #313131;
        }
      }
    }
  }
  .purchase-items{
    .title{
      margin-bottom: 30px;
    }
    .purchase-card{
      display: grid;
      gap: 15px;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      .card{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        background-color: #fff;
        padding: 10px;
        border-radius: 15px;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
        .image-wrap{
          max-width: 94px;
          img{
            width: 100%;
            height: auto;
          }
        }
        .text-wrap{
          font-size: 14px;
          line-height: 18px;
          font-weight: 300;
          strong{
            display: block;
            margin-bottom: 8px;
            font-size: 16px;
            line-height: 18px;
            font-weight: 400;
          }
          span{
            font-weight: 400;
            color: rgba(49, 49, 49, 0.75);
          }
        }
      }
    }
  }
`;
